// assets/wishlist.js

// ─── Core State ───────────────────────────────────────────────────────────────

const Wishlist = {
  _cache: null,

  get() {
    if (!this._cache) {
      this._cache = new Set(JSON.parse(localStorage.getItem("wishlist")) || []);
    }
    return this._cache;
  },

  save() {
  localStorage.setItem("wishlist", JSON.stringify([...this.get()]));
  window.updateWishlistBubble?.();
  document.dispatchEvent(new CustomEvent('wishlist:updated'));
},

  toggle(handle) {
    const list = this.get();
    const isRemoving = list.has(handle);
    isRemoving ? list.delete(handle) : list.add(handle);
    this.save();
    return isRemoving;
  },

  has(handle) {
    return this.get().has(handle);
  }
};

// ─── Product Fetch Cache ───────────────────────────────────────────────────────

const productCache = new Map();

async function fetchProduct(handle) {
  if (productCache.has(handle)) return productCache.get(handle);

  const response = await fetch(`/products/${handle}.js`);
  if (!response.ok) throw new Error(`Failed to fetch product: ${handle}`);

  const product = await response.json();
  productCache.set(handle, product);
  return product;
}

// ─── Button State ─────────────────────────────────────────────────────────────

function syncButton(button, handle) {
  button.classList.toggle("active", Wishlist.has(handle));
}

function initializeWishlistButtons(root = document) {
  const wishlist = Wishlist.get();
  root.querySelectorAll(".wishlist-button").forEach(button => {
    const handle = button.dataset.productHandle;
    if (handle) button.classList.toggle("active", wishlist.has(handle));
  });
}

// ─── Click Handler ────────────────────────────────────────────────────────────

document.addEventListener("click", async function (e) {
  const button = e.target.closest(".wishlist-button");
  const handle = button?.dataset.productHandle;
  if (!handle) return;

  const isRemoving = Wishlist.toggle(handle);
  syncButton(button, handle);

  try {
    const product = await fetchProduct(handle);
    window.showWishlistToast?.(product, isRemoving ? "remove" : "add");
  } catch (error) {
    console.error("Wishlist fetch error:", error);
  }
});

// ─── Init ─────────────────────────────────────────────────────────────────────

document.addEventListener("DOMContentLoaded", function () {
  initializeWishlistButtons();
  window.updateWishlistBubble?.();

  // Observe dynamic product recommendations in a single DOMContentLoaded block
  const recommendations = document.querySelector("product-recommendations");
  if (!recommendations) return;

  const observer = new MutationObserver(() => initializeWishlistButtons(recommendations));
  observer.observe(recommendations, { childList: true, subtree: true });
});

